import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "icon-show-more__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-show-more__dash" }, " "),
  /*#__PURE__*/_createElementVNode("div", { class: "icon-show-more__dash" }, " ")
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["icon-show-more", { 'icon-show-more--closed': _ctx.isClosed }])
  }, _hoisted_2, 2))
}